<script>
  import QRCode from 'qrcode';

  let { roomId } = $props();

  let canvasEl = $state(null);
  let joinUrl = $derived(buildJoinUrl(roomId));

  function buildJoinUrl(id) {
    if (!id) return '';
    const base = `${location.origin}${location.pathname}`;
    return `${base}?room=${encodeURIComponent(id)}`;
  }

  $effect(() => {
    if (!canvasEl || !joinUrl) return;
    QRCode.toCanvas(canvasEl, joinUrl, {
      width: 240,
      margin: 2,
      color: { dark: '#0f172a', light: '#ffffff' },
    }).catch((err) => console.error('QR error', err));
  });

  function copyJoinUrl() {
    if (!joinUrl) return;
    navigator.clipboard.writeText(joinUrl).then(() => alert('Link copiado'));
  }
</script>

<div class="qr-wrap">
  <canvas bind:this={canvasEl} aria-label="Código QR para unirse a la sala"></canvas>
  <div class="qr-url">{joinUrl}</div>
  <button class="secondary" onclick={copyJoinUrl}>Copiar link</button>
</div>

<style>
  .qr-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin-top: 12px;
    padding: 16px;
    background: #ffffff;
    border-radius: 12px;
  }
  .qr-wrap canvas {
    display: block;
    border-radius: 6px;
  }
  .qr-url {
    font-size: 0.78rem;
    color: #334155;
    word-break: break-all;
    text-align: center;
    max-width: 260px;
  }
</style>
